module.exports = __webpack_public_path__ + "static/media/voucher-icon.4af44319.svg";